import { namespacedConsts } from 'utils/object';

export const JWPLAYER_ACTION_TYPES = namespacedConsts({
  SDK_LOADED: true,
  LOAD_SDK: true,
  ANALYTICS: {
    VIDEO_PLAY: true,
    VIDEO_COMPLETE: true,
    VIDEO_PAUSE: true,
    VIDEO_BUFFER_CHANGE: true,
    VIDEO_ERROR: true,
  }
});

export const loadSdk = _ => ({
  type: JWPLAYER_ACTION_TYPES.LOAD_SDK,
});

export const sdkLoaded = _ => ({
  type: JWPLAYER_ACTION_TYPES.SDK_LOADED,
});

export const jwplayerAnalyticsPlayAction = (videoId) => ({
  type: JWPLAYER_ACTION_TYPES.ANALYTICS.VIDEO_PLAY,
  payload: {
    eventName: 'video play',
    videoId
  },
});
export const jwplayerAnalyticsCompleteAction = (videoId) => ({
  type: JWPLAYER_ACTION_TYPES.ANALYTICS.VIDEO_COMPLETE,
  payload: {
    eventName: 'video complete',
    videoId
  },
});

export const jwplayerAnalyticsPauseAction = (videoId) => ({
  type: JWPLAYER_ACTION_TYPES.ANALYTICS.VIDEO_PAUSE,
  payload: {
    eventName: 'video pause',
    videoId
  },
});
export const jwplayerAnalyticsBufferChangeAction = (videoId, buffer) => ({
  type: JWPLAYER_ACTION_TYPES.ANALYTICS.VIDEO_BUFFER_CHANGE,
  payload: {
    eventName: 'video buffer',
    videoId,
    buffer
  },
});
export const jwplayerAnalyticsErrorAction = (videoId) => ({
  type: JWPLAYER_ACTION_TYPES.ANALYTICS.VIDEO_ERROR,
  payload: {
    eventName: 'video error',
    videoId
  },
});


// WEBPACK FOOTER //
// ./provolution/app/views/provolution/components/jwplayer/jwplayerActions.js